import { Circle, BookOpen, Flag } from "react-feather";

import {
  EDUCATIONAL_CONTENT_PATH,
  FEATURED_CONTENT_PATH,
  LEGAL_PAGES_PATH,
  FAQ_PATH,
} from "@src/views/apps/content/paths";
import {
  REVIEW_QUEUE_PATH,
  REPORTED_CONTENT_PATH,
} from "@src/views/apps/content-moderation/paths";
import { navPerm } from "../navPermissions";
import { PERMISSION_MODULE } from "@src/utility/permissions/modulePermissions";

export default [
  {
    header: "Content",
  },
  {
    id: "content-management",
    title: "Content Management",
    icon: <BookOpen size={20} />,
    children: [
      {
        id: "educational-content",
        title: "Educational Content",
        icon: <Circle size={12} />,
        navLink: EDUCATIONAL_CONTENT_PATH,
        ...navPerm(PERMISSION_MODULE.EDUCATIONAL_CONTENT),
      },
      {
        id: "featured-content",
        title: "Promotional Content",
        icon: <Circle size={12} />,
        navLink: FEATURED_CONTENT_PATH,
        ...navPerm(PERMISSION_MODULE.PROMOTIONAL_CONTENT),
      },
      {
        id: "legal-pages",
        title: "Legal Pages",
        icon: <Circle size={12} />,
        navLink: LEGAL_PAGES_PATH,
        ...navPerm(PERMISSION_MODULE.LEGAL_PAGE),
      },
      {
        id: "faq",
        title: "FAQ",
        icon: <Circle size={12} />,
        navLink: FAQ_PATH,
        ...navPerm(PERMISSION_MODULE.FAQ),
      },
    ],
  },
  {
    id: "content-moderation",
    title: "Content Moderation",
    icon: <Flag size={20} />,
    children: [
      {
        id: "moderation-review-queue",
        title: "Review Queue",
        icon: <Circle size={12} />,
        navLink: REVIEW_QUEUE_PATH,
        ...navPerm(PERMISSION_MODULE.REVIEW_QUEUE),
      },
      {
        id: "moderation-reported-content",
        title: "Reported Content",
        icon: <Circle size={12} />,
        navLink: REPORTED_CONTENT_PATH,
        ...navPerm(PERMISSION_MODULE.REPORTED_CONTENT),
      },
    ],
  },
];
